import React, { useState, useEffect } from "react";
import { Layout, Menu, Button } from "antd";
import {
  HomeOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined, // Import the missing icon
  CloseOutlined,
  SettingOutlined,
  TeamOutlined,
  DashboardOutlined,
} from "@ant-design/icons";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Nav from "../../../components/Nav/Nav";
import sidebarStyles from "../../../components/Sidebar/sidebarStyles.js";

import GuestHome from "../../../assets/Icons/guesthome.jpg";

const { Sider, Header, Content, Footer } = Layout;

// A simple hook to get the window width
const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowWidth;
};

const SalesLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // --- MODIFICATION START ---
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 768;

  const desktopSidebarWidth = collapsed ? 80 : 250;
  const contentMarginLeft = isMobile ? 0 : desktopSidebarWidth;
  // --- MODIFICATION END ---

  const menuItems = [
    {
      key: "sales",
      icon: <DashboardOutlined />,
      label: "Dashboard",
      onClick: () => {
        navigate("/sales/sales-dashboard");
        setMobileOpen(false);
      },
    },
    {
      key: "sales-agents",
      icon: <TeamOutlined />,
      label: "Agents",
      onClick: () => {
        navigate("/sales/sales-agent");
        setMobileOpen(false);
      },
    },
    {
      key: "sales-houses",
      icon: <HomeOutlined />,
      label: "House List",
      onClick: () => {
        navigate("/sales/sales-house");
        setMobileOpen(false);
      },
    },
    {
      key: "sales-setting",
      icon: <SettingOutlined />,
      label: "Settings",
      onClick: () => {
        navigate("/sales/sales-setting");
        setMobileOpen(false);
      },
    },
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      onClick: () => {
        navigate("/logout");
        setMobileOpen(false);
      },
    },
  ];

  const getDefaultSelectedKey = () => {
    const path = location.pathname;
    if (path.includes("/sales-agent")) return ["sales-agents"];
    if (path.includes("/sales-house")) return ["sales-houses"];
    if (path.includes("/sales-setting")) return ["sales-setting"];
    if (path.includes("/sales-dashboard")) return ["sales"];
    return ["sales"]; // Fallback
  };

  return (
    <Layout className="min-h-screen">
      <style>{sidebarStyles}</style>

      {/* Sidebar - Desktop (Fixed) */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        trigger={null}
        className="hidden md:flex main-sidebar flex-col shadow-md"
        width={250}
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        <div className="admin-card flex items-center gap-3">
          <div className="profile-pic-wrapper">
            <img src={GuestHome} alt="Admin Avatar" />
          </div>
          {!collapsed && (
            <div className="admin-info">
              <span className="text-base font-semibold block">
                GuestHome PLC
              </span>
              <span className="admin-role block">Sales Dashboard</span>
            </div>
          )}
        </div>
        <Menu
          defaultSelectedKeys={getDefaultSelectedKey()}
          mode="inline"
          items={menuItems}
          inlineCollapsed={collapsed}
        />
      </Sider>

      {/* Mobile - Sidebar (Overlay) */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden"
          onClick={() => setMobileOpen(false)}
        >
          <Sider
            className="h-full main-sidebar shadow-lg flex flex-col"
            width={240}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mobile-sidebar-header">
              <span className="mobile-title">Menu</span>
              <Button
                className="close-button"
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setMobileOpen(false)}
              />
            </div>
            <Menu
              defaultSelectedKeys={getDefaultSelectedKey()}
              mode="inline"
              items={menuItems}
            />
          </Sider>
        </div>
      )}

      {/* Main Layout - MODIFIED */}
      <Layout
        className="flex-1 flex flex-col min-h-screen transition-all duration-300"
        style={{ marginLeft: contentMarginLeft }}
      >
        <Header className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center">
            {/* Desktop Toggle Button - ADDED */}
            <Button
              className="hidden md:block bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white rounded-md border-none mr-4"
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
            />
            {/* Mobile Toggle Button */}
            <Button
              className="md:hidden bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white rounded-md border-none"
              type="default"
              onClick={() => setMobileOpen(true)}
            >
              <MenuUnfoldOutlined />
            </Button>
          </div>
          <div className="flex-grow">
            <Nav />
          </div>
        </Header>
        
        <Content className="flex-1 p-4 bg-gray-100 dark:bg-gray-800 overflow-y-auto">
          <Outlet />
        </Content>

        <Footer className="bg-white dark:bg-gray-900 text-center p-4 text-gray-600 dark:text-gray-300">
          GuestHome PLC ©{new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  );
};

export default SalesLayout;
